module.exports = __webpack_public_path__ + "static/media/3.59ba67cb.png";